import { Grid } from "@mui/material";
import { loadLocalImage } from "../../../../utils";
import {
  AnsImageLink,
  ContainerGrid,
  IconImage,
  Rights,
  StyledBox,
} from "../styles/FooterStyles";

const socialLinks = [
  {
    href: "https://www.facebook.com/SulAmerica",
    image: "icon-facebook.png",
    alt: "Facebook",
    label: "Abrir Facebook da SulAmérica",
  },
  {
    href: "https://twitter.com/SulAmerica",
    image: "icon-twitter.png",
    alt: "Twitter",
    label: "Abrir Twitter da SulAmérica",
  },
  {
    href: "https://www.youtube.com/SulAmerica",
    image: "icon-youtube.png",
    alt: "YouTube",
    label: "Abrir YouTube da SulAmérica",
  },
  {
    href: "https://www.linkedin.com/company-beta/264362/?pathWildcard=264362",
    image: "icon-linkedin.png",
    alt: "LinkedIn",
    label: "Abrir LinkedIn da SulAmérica",
  },
];

const ansImages = [
  {
    image: "logo-ans.png",
    alt: "Logo da ANS",
  },
  {
    image: "selo-ans-3.jpg",
    alt: "Selo da ANS 3",
  },
  {
    image: "selo-ans.png",
    alt: "Selo da ANS",
  },
];

export const Footer = () => {
  return (
    <StyledBox>
      <ContainerGrid>
        <Grid
          container
          marginBottom={2}
          alignItems="center"
          flexDirection={{ xs: "column", sm: "row" }}
          sx={{ paddingTop: 2 }}
        >
          <Grid size={{ xs: 12, sm: 3, md: 4 }} sx={{ padding: "15px 5px" }} textAlign="center">
            {socialLinks.map(({ href, image, alt, label }) => (
              <a
                key={href}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
              >
                <IconImage src={loadLocalImage(image, "footer")} alt={alt} />
              </a>
            ))}
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 4 }} sx={{ padding: "15px 5px" }}>
            <Rights as="p">©2017 SulAmérica - Todos os direitos reservados</Rights>
          </Grid>

          <Grid size={{ xs: 12, sm: 3, md: 4 }} sx={{ padding: "15px 5px" }}>
            <AnsImageLink
              href="https://www.gov.br/ans/pt-br"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Abrir site da ANS"
            >
              <Grid
                container
                alignItems="center"
                flexDirection="row"
                justifyContent={{ sm: "flex-end" }}
              >
                {ansImages.map(({ image, alt }) => (
                  <IconImage
                    key={image}
                    src={loadLocalImage(image, "footer")}
                    alt={alt}
                  />
                ))}
              </Grid>
            </AnsImageLink>
          </Grid>
        </Grid>
      </ContainerGrid>
    </StyledBox>
  );
};

export default Footer;